import React from "react";
import styles from "./style.module.scss";
import topImage from "../../../../static/top.jpeg";
import FeedIn from "../../../components/FramerMotion/FeedIn";
import PreloadImage from "../../../components/Image";
import { useImagePresenter } from "../../../components/Image/useImagePresenter";
import { motion } from "framer-motion";

const TopView = () => {
  const { loaded } = useImagePresenter(topImage);

  return (
    <div className={styles.section}>
      <div className={styles.imageWrapper}>
        <PreloadImage
          imgUrl={topImage}
          className={styles.image}
          loaded={loaded}
        />

        <div className={styles.CatchCopies}>
          {loaded && (
            <>
              <motion.div
                className={styles.CatchCopy1}
                initial={{ scaleX: 0 }}
                animate={{
                  scaleX: 1,
                  transformOrigin: "center left",
                  transition: { duration: 0.5 },
                }}
              >
                <motion.p
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: 1,
                    transition: { duration: 1.5 },
                  }}
                >
                  設計から生産まで、
                </motion.p>
              </motion.div>
              <motion.div
                className={styles.CatchCopy2}
                initial={{ scaleX: 0 }}
                animate={{
                  scaleX: 1,
                  transformOrigin: "center left",
                  transition: { duration: 0.5 },
                }}
              >
                <motion.p
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: 1,
                    transition: { duration: 1.5 },
                  }}
                >
                  事業を支えるものづくり
                </motion.p>
              </motion.div>
            </>
          )}
        </div>
      </div>
      <div className={styles.introductionArea}>
        <FeedIn>
          <p className={styles.name}>株式会社ミヤザワ</p>
          <p className={styles.abstract}>
            長野県上田市を拠点に、金型の設計から製造、
            <br />
            プラスチック成形までトータルに生産する会社です。
          </p>
        </FeedIn>
      </div>
    </div>
  );
};

export default TopView;
